import useAuthenticatedFetch from "@/hooks/useAuthenticatedFetch.ts";
import { type CaseTasksDocument, caseTaskCollectionResourceSelector } from "@/types/caseTask.ts";
import { apiUrl } from "@/utils/api.ts";
import { type UseQueryResult, useQuery } from "@tanstack/react-query";

type Props = {
    idUUID: string;
};

export const useFetchCaseTasks = ({ idUUID }: Props): UseQueryResult<CaseTasksDocument> => {
    const fetch = useAuthenticatedFetch();

    return useQuery({
        queryKey: ["case-tasks", idUUID],
        enabled: idUUID !== undefined,
        queryFn: async () => {
            const response = await fetch(apiUrl("/case-task/for-case"), {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    idUUID,
                }),
            });

            return await response.json();
        },
        select: caseTaskCollectionResourceSelector,
    });
};
